import React from 'react';

const SvgCaret = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    {...props}
  >
    <path
      d="M0.979642 0.730469H9.02027C9.57652 0.730469 9.85464 1.40234 9.46089 1.79609L5.44214 5.81797C5.19839 6.06172 4.80152 6.06172 4.55777 5.81797L0.539017 1.79609C0.145267 1.40234 0.423392 0.730469 0.979642 0.730469Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgCaret;
